var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-item",style:(_vm.style)},[_c('router-link',{attrs:{"to":_vm.link}},[_c('i',{class:_vm.icon}),(_vm.svg)?_c('inline-svg',{staticStyle:{"margin-bottom":"15px"},attrs:{"src":require(`@/assets/icons/${_vm.svg}`),"fill":_vm.color,"height":_vm.height}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }